import { DefaultState } from '@src/redux/types'

import {
  HELP_DESK_TICKETS,
  HELP_DESK_TICKETS_ALL,
  HELP_DESK_TICKETS_CREATE,
  HELP_DESK_TICKETS_DELETE,
  HELP_DESK_TICKETS_LIST,
  HELP_DESK_TICKETS_OWN,
  HELP_DESK_TICKETS_UPDATE,
} from '../constants/actionTypes'
import * as API from '../constants/api'

export const defaultState = () => ({ loading: false, error: null, data: null })

export const initialState: () => {
  [HELP_DESK_TICKETS]: DefaultState<`${typeof API.HELP_DESK_TICKETS}{id}`, 'get'>
  [HELP_DESK_TICKETS_ALL]: DefaultState<`${typeof API.HELP_DESK_TICKETS_ALL}`, 'get'>
  [HELP_DESK_TICKETS_LIST]: DefaultState<`${typeof API.HELP_DESK_TICKETS}`, 'get'>
  [HELP_DESK_TICKETS_UPDATE]: DefaultState<`${typeof API.HELP_DESK_TICKETS}`, 'put'>
  [HELP_DESK_TICKETS_CREATE]: DefaultState<`${typeof API.HELP_DESK_TICKETS}`, 'post'>
  [HELP_DESK_TICKETS_DELETE]: DefaultState<`${typeof API.HELP_DESK_TICKETS}{id}`, 'delete'>
  [HELP_DESK_TICKETS_OWN]: DefaultState<`${typeof API.HELP_DESK_TICKETS_OWN}`, 'get'>
} = () => ({
  [HELP_DESK_TICKETS]: defaultState(),
  [HELP_DESK_TICKETS_ALL]: defaultState(),
  [HELP_DESK_TICKETS_LIST]: defaultState(),
  [HELP_DESK_TICKETS_UPDATE]: defaultState(),
  [HELP_DESK_TICKETS_CREATE]: defaultState(),
  [HELP_DESK_TICKETS_DELETE]: defaultState(),
  [HELP_DESK_TICKETS_OWN]: defaultState(),
})
